import { useAuth } from "../hooks/AuthProvider";
import AsyncImage from "./AsyncImage";
function Profile() {
  const profile = useAuth();

  // Example Google profile json
  // {
  //   email:"danielbeiers@gmail.com"
  //   family_name:"Beiers"
  //   given_name:"Daniel"
  //   id:"107255783574100850137"
  //   name:"Daniel Beiers"
  //   picture:"https://lh3.googleusercontent.com/a/ACg8ocII6_9TRpT4f5cKncWe_3F55ATldf1qujt2jyGemjM6kPamAg=s96-c"
  //   verified_email:true
  // }

  return (
    <div className="profile-container">
      <div className="profile-top">
        <AsyncImage
          className="profile-picture"
          src={profile.user.picture}
          alt="profile picture"
        />
        <p>{profile.user.email}</p>
      </div>
      <div className="profile-bottom">
        <ul>
          <li>Name: {profile.user.name}</li>
          <li>Verified: {profile.user.verified_email.toString()}</li>
        </ul>
      </div>
    </div>
  );
}
export default Profile;
